import { InputBase, useMediaQuery } from "@mui/material";
import type { FC, KeyboardEvent, RefObject } from "react";
import { shouldSubmitOnEnter } from "web_myplann/Chat/Helpers/shouldSubmitOnEnter";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	inputRef: RefObject<HTMLTextAreaElement | null>;
	value: string;
	onChange: (value: string) => void;
	onSubmit: () => void;
};

const MAX_ROWS = 6;

export const ChatComposerInput: FC<Props> = ({
	inputRef,
	value,
	onChange,
	onSubmit,
}) => {
	const { t } = useResource();
	const isTouchDevice = useMediaQuery("(pointer: coarse)");

	const handleKeyDown = (
		event: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>,
	) => {
		const submits = shouldSubmitOnEnter({
			key: event.key,
			shiftKey: event.shiftKey,
			isComposing: event.nativeEvent.isComposing,
			isTouchDevice,
		});
		if (!submits) return;

		event.preventDefault();
		onSubmit();
	};

	return (
		<InputBase
			variant="pill"
			inputRef={inputRef}
			value={value}
			onChange={(event) => onChange(event.target.value)}
			onKeyDown={handleKeyDown}
			multiline
			maxRows={MAX_ROWS}
			placeholder={t(Resources.Chat.inputPlaceholder)}
			sx={{ flex: 1, minWidth: 0 }}
		/>
	);
};
